<nav>
  <ul class="header-navigation-list">
    <li *ngFor="let item of navigationItems" class="header-navigation-item">
      <a [routerLink]="[item.url]" [routerLinkActive]="'active'">{{
        item.label
      }}</a>
    </li>
  </ul>
</nav>
